export default __webpack_public_path__ + "static/media/front-end-guild-background.69948932.png";